import WebServiceRequest from "../../Api/WebServiceRequest";

class GuildCreate extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Guild/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default GuildCreate;
